import api from '@/redux/api/topRatedSellers';
import { createSelector } from 'reselect';
import { getAuthToken } from './user';
import { getDeployment } from './config';
import { GlobalState } from '../rootReducer';
import ms from 'ms';

/* Action Types */
export const LOAD_TOP_RATED_SELLERS_FAIL = 'la/domain/topRatedSellers/LOAD_FAIL';
export const LOAD_TOP_RATED_SELLERS_REQUEST = 'la/domain/topRatedSellers/LOAD_REQUEST';
export const LOAD_TOP_RATED_SELLERS_SUCCESS = 'la/domain/topRatedSellers/LOAD_SUCCESS';

const REDUX_STORE_TIME = ms('30m');

/* Reducer */
const DEFAULT_STATE = {
    loaded: {
        isLoaded: false,
        time: 0,
    },
    topRatedSellers: [],
};

export type State = typeof DEFAULT_STATE;

export default function reducer(state: State = DEFAULT_STATE, action: any = {}) {
    switch (action.type) {
        case LOAD_TOP_RATED_SELLERS_SUCCESS:
            return {
                ...state,
                loaded: {
                    isLoaded: true,
                    time: action.meta.actionTime,
                },
                topRatedSellers: action.payload,
            };
        default:
            return state;
    }
}

/* Seletors */
const stateSelector = (state: GlobalState) => state.topRatedSellers;
const idSelector = (state: GlobalState, id: number) => id;

const topRatedSellersSelector = createSelector(stateSelector, (state) => state.topRatedSellers);

export const isTopRatedHouse: (arg0: any, arg1: number) => boolean = createSelector(
    [topRatedSellersSelector, idSelector],
    (topRatedSellers, sellerId) => topRatedSellers.includes(sellerId)
);

const getTopRatedSellersLoaded = createSelector(stateSelector, (state) => state.loaded);

/* Action Creators */
export const fetchTopSellersIfNeeded = () => async (dispatch: Function, getState: Function) => {
    try {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const loaded = getTopRatedSellersLoaded(state);

        const needsRefresh = !loaded.time || Date.now() - loaded.time > REDUX_STORE_TIME;
        if (loaded.isLoaded && !needsRefresh) {
            return;
        }
        dispatch({
            type: LOAD_TOP_RATED_SELLERS_REQUEST,
        });
        const response = await api.getTopRatedHouses({ authToken, deployment });
        dispatch({
            meta: { actionTime: Date.now() },
            payload: response.payload || [],
            type: LOAD_TOP_RATED_SELLERS_SUCCESS,
        });
    } catch (error) {
        dispatch({
            error: true,
            payload: error,
            type: LOAD_TOP_RATED_SELLERS_FAIL,
        });
    }
};
